{
  "REGISTER": {
    "TRY_WOOT": "Opret en konto",
    "TITLE": "Registrer",
    "TESTIMONIAL_HEADER": "Alt, hvad der skal til, er blot et skridt for at komme videre",
    "TESTIMONIAL_CONTENT": "Du er et skridt fra at engagere dine kunder, fastholde dem og finde nye kunder.",
    "TERMS_ACCEPT": "Ved at oprette en konto, accepterer du vores <a href=\"https://chat.jarabot.com/terms\">T & C</a> og <a href=\"https://chat.jarabot.com/privacy-policy\">Privatlivspolitik</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Vilkår og betingelser</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Privatlivspolitik</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Tilmeld dig med Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Firmanavn",
      "PLACEHOLDER": "Indtast dit firmanavn, fx: Wayne Enterprises",
      "ERROR": "Firmanavn er for kort"
    },
    "FULL_NAME": {
      "LABEL": "Fulde navn",
      "PLACEHOLDER": "Indtast dit fulde navn. fx: Bruce Wayne",
      "ERROR": "Fulde navn er for kort"
    },
    "EMAIL": {
      "LABEL": "Arbejde e-mail",
      "PLACEHOLDER": "Indtast din arbejdsmailadresse. F.eks. navn{'@'}eksempel{'.'}dk",
      "ERROR": "Indtast venligst en gyldig arbejdsmail"
    },
    "PASSWORD": {
      "LABEL": "Adgangskode",
      "PLACEHOLDER": "Adgangskode",
      "ERROR": "Adgangskoden er for kort",
      "IS_INVALID_PASSWORD": "Adgangskoden skal indeholde mindst 1 stort bogstav, 1 lille bogstav, 1 nummer og 1 specialtegn"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Bekræft Adgangskode",
      "PLACEHOLDER": "Bekræft Adgangskode",
      "ERROR": "Adgangskode stemmer ikke overens"
    },
    "API": {
      "SUCCESS_MESSAGE": "Registrering Succesfuld",
      "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
    },
    "SUBMIT": "Opret en konto",
    "HAVE_AN_ACCOUNT": "Har du allerede en konto?"
  }
}
